<template>
  <ChapterBlockTemplateLinkItem
    :id="category.id"
    :text="category.title"
    :path="routeLink.path"
    :content-type="category.contentType"
    :locked-content="category.lockedContent"
  />
</template>
<script lang="ts" setup>
import type { CategorySchema } from '~/types/schema';
import { getCategoryRouterAction } from '~/lib/category/actionHelper';
interface Props {
  category: CategorySchema;
}

const { currentContent, categoryLockState } = inject(INJECT_CATEGORY_PAGE);

const route = useRoute();

const { $db } = useNuxtApp();

const props = defineProps({
  category: null
});

const { routeLink } = await getCategoryRouterAction(
  $db,
  props.category,
  currentContent.value,
  categoryLockState.value.getIsTypeLocked,
  route.path
);
</script>
<style lang="scss" scoped></style>
